/**
 * Komponent WiseChartTopBar dla WiseChart - wyświetla label, amount i parametry
 */

import React, { FC, useMemo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button as ButtonMui } from '@mui/material';
import { useAppTheme } from 'theme/useAppTheme';

import { WiseRangeButton, IRangeParameter } from 'components/wise';
import { IActiveParameter, IWiseChartParameter, WiseQueryParams } from 'components/wise/types';

import { X } from 'react-bootstrap-icons';
import styles from 'theme/components/wise/WiseChart/components/WiseChartTopBar/WiseChartTopBar.module.scss';

interface IWiseChartTopBarProps {
  label: string;
  amount: string;
  parameters: IWiseChartParameter[];
  queryParams: WiseQueryParams;
  activeParameters: IActiveParameter[];
  updateParameter: (fieldSymbol: string, value: any) => void;
  handleClearParameters: () => void;
}

const WiseChartTopBar: FC<IWiseChartTopBarProps> = ({
  label,
  amount,
  parameters,
  activeParameters,
  queryParams,
  handleClearParameters,
  updateParameter
}) => {
  const { t } = useTranslation();
  const theme = useAppTheme();

  const amountNumber = parseFloat(amount) || 0;
  const formattedAmount = amountNumber.toFixed(2) + 'zł';

  const hasActiveParameters = useMemo(() => {
    return activeParameters.length > 0;
  }, [activeParameters]);

  return (
    <div className={classnames(styles.topBar, 'WiseChartTopBar')}>
      <div className={styles.leftSection}>
        <div className={styles.label}>{label}</div>
        <div className={styles.amount}>{formattedAmount}</div>
      </div>
      <div className={styles.rightSection}>
        {parameters.length > 0 && (
          <div className={styles.parametersWrapper}>
            {parameters.map((parameter, i) => {
              if (parameter.type === 'date_range' || parameter.type === 'range') {
                return (
                  <div key={i}>
                    <WiseRangeButton
                      parameter={parameter as IRangeParameter}
                      queryParams={queryParams}
                      updateParameter={updateParameter}
                    />
                  </div>
                );
              }
              return null;
            })}
          </div>
        )}
        {hasActiveParameters && (
          <ButtonMui
            variant="text"
            color="secondary"
            onClick={handleClearParameters}
            startIcon={<X />}
            sx={{
              lineHeight: '28px',
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '14px',
              color: theme.palette.app.textMutedAlpha,
              '&:hover': {
                color: theme.palette.app.secondaryLight,
                backgroundColor: theme.palette.app.hoverBg
              }
            }}>
            {t('Wyczyść filtry')}
          </ButtonMui>
        )}
      </div>
    </div>
  );
};

export default WiseChartTopBar;
